export const s1 = [
    {
        "anio" : "Asistencia a Proyectos Turísticos",
        "descripcion" : "Orientar y determinar los alcances de un Proyecto Turístico para su viabilidad",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "http://ruts.hidalgo.gob.mx/ver/1182"
            },
           
        ]
    },{
        "anio" : "Certificaciones",
        "descripcion" : "Trámite dirigido a empresas del giro turístico con el fin de obtener la certificación",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "http://ruts.hidalgo.gob.mx/ver/6600"
            },
            
        ]
    },{
        "anio" : "RNT",
        "descripcion" : "Registro Nacional de Turismo",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "http://ruts.hidalgo.gob.mx/ver/8130"
            },
            
        ]
    },{
        "anio" : "Cursos de Capacitación",
        "descripcion" : "Cursos de capacitación a prestadores de Servicios Turísticos y de Primer Contacto",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "https://ruts.hidalgo.gob.mx/ver/11022"
            }
        ]
    }
]